
import { createContext } from 'react';
import { AuthContextType } from './types';

// Create the auth context with default values
export const AuthContext = createContext<AuthContextType>({
  user: null,
  profile: null,
  session: null,
  loading: true,
  authChangeProcessed: false,
  isAdmin: false,
  roleLoadError: false,
  login: async () => false,
  signup: async () => false,
  logout: async () => {},
  updateProfile: async () => false,
  updatePassword: async () => ({ success: false, message: 'Not implemented' }),
});
